import React, { useState } from 'react';
import './App.css';
import { FaCloud, FaDesktop, FaServer, FaPhone, FaEnvelope } from 'react-icons/fa';
 
function App() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: '',
  });
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Send the form data to the PHP script using a POST request
    const form = new FormData();
    form.append('name', formData.name);
    form.append('email', formData.email);
    form.append('phone', formData.phone);
    form.append('subject', formData.subject);
    form.append('message', formData.message);

    try {
       const domainUrl = window.location.origin;
       const response = await fetch(`${domainUrl}/contact-form/send-email.php`, {
        method: 'POST',
        body: form,
      });
      

      const result = await response.text();
      if (result.includes('Message sent successfully')) {
        alert('Message sent successfully!');
      } else {
        alert('Failed to send message.');
      }
    } catch (error) {
      console.error('Error sending email:', error);
      alert('Error sending message.');
    }
  };
  
  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };
	
  return (
    <div className="App">
      <header className="App-header">
        <img src="/headerlogo.png" alt="Kloud Solutions Logo" className="App-logo" />
		{/* Email Address in Right Corner */}
      </header>

      {/* Navigation Bar */}
      <nav className="navbar">
        {/* Hamburger Icon for Mobile */}
        <div className="hamburger-icon" onClick={toggleMenu}>
          <span className="bar"></span>
          <span className="bar"></span>
          <span className="bar"></span>
        </div>

        {/* Navbar Links */}
        <ul className={`navbar-list ${menuOpen ? 'active' : ''}`}>
          <li><a href="#home" className="navbar-link">Home</a></li>
          <li><a href="#web-hosting" className="navbar-link">Web Hosting</a></li>
          <li><a href="#cloud" className="navbar-link">Cloud & Infrastructure</a></li>
          <li><a href="#contact-us" className="navbar-link">Contact Us</a></li>
        </ul>
      </nav>
    

      <main>
        {/* About Us Section with Background */}
        <section className="hosting-solutions" id="home">
          <div className="about-us-content">
            <h2>About Us</h2>
            <p>
              At Kloud Solutions, we empower businesses with cutting-edge cloud technology to drive innovation, efficiency, and scalability. Our mission is to simplify cloud adoption and management, providing seamless solutions tailored to your unique business needs.
            </p>
            <p>
              With expertise in cloud computing, infrastructure management, cybersecurity, and digital transformation, we help organizations harness the full potential of the cloud—whether through migration, optimization, or ongoing support.
            </p>
            <p>
              Our team of cloud specialists is dedicated to delivering secure, scalable, and cost-effective solutions, ensuring that businesses of all sizes can thrive in today’s digital-first world.
            </p>
            <p>
              Whether you're looking to modernize your IT infrastructure, enhance data security, or leverage cloud-native applications, Kloud Solutions is your trusted partner for success in the cloud.
            </p>
            <p>
              Innovate. Scale. Secure. Welcome to the future of cloud technology with Kloud Solutions.
            </p>
          </div>
        </section>

        {/* Explore Our Web Hosting Solutions Section */}
        <section className="hosting-solutions">
          <h2>Our Solutions</h2>
          <div className="hosting-options">
            <div className="hosting-option">
              <FaDesktop size={50} color="#0066cc" />
              <h3>GPU Hosting</h3>
              <p>
                In today’s fast-paced digital world, having the right computing power is essential for running high-performance applications...
              </p>
            </div>

            <div className="hosting-option">
              <FaDesktop size={50} color="#0066cc" />
              <h3>VPS Hosting</h3>
              <p>
                For those needing more control and dedicated resources, our Virtual Private Server (VPS) hosting is the perfect solution...
              </p>
            </div>

            <div className="hosting-option">
              <FaServer size={50} color="#0066cc" />
              <h3>Dedicated Hosting</h3>
              <p>
                When your website or application demands top-tier performance and reliability, our dedicated hosting is the ideal choice...
              </p>
            </div>

            <div className="hosting-option">
              <FaCloud size={50} color="#0066cc" />
              <h3>Cloud Hosting</h3>
              <p>
                Our cloud hosting solutions provide unmatched flexibility and scalability, making them ideal for businesses that need to adapt quickly...
              </p>
            </div>
          </div>
        </section>

        {/* Windows Web Hosting Section (Displayed in One Line) */}
        <section className="hosting-solutions" id="web-hosting">
          <h2>Web Hosting</h2>
          
<div className="hosting-plans">
  {/* VPS Hosting Plan */}
  <div className="hosting-plan">
    <h3>VPS Hosting</h3>
    <hr className="plan-divider" />
    <ul className="plan-features">
      <li>Virtual Private Server</li>
      <li>Customizable Resources</li>
      <li>SSD Storage</li>
      <li>Full Root Access</li>
      <li>High Performance CPUs</li>
      <li>Dedicated IP Address</li>
      <li>Advanced Security Features</li>
      <li>Free Backup & Recovery</li>
      <li>Unmetered Bandwidth</li>
      <li>24/7 Technical Support</li>
    </ul>
  </div>

  {/* Dedicated Hosting Plan */}
  <div className="hosting-plan">
    <h3>Dedicated Hosting</h3>
    <hr className="plan-divider" />
    <ul className="plan-features">
      <li>Full Dedicated Server</li>
      <li>Enterprise-grade Hardware</li>
      <li>Custom Configurations</li>
      <li>High Availability & Reliability</li>
      <li>Free cPanel/WHM License</li>
      <li>Root & Administrative Access</li>
      <li>Premium DDoS Protection</li>
      <li>Unlimited Traffic</li>
      <li>Free SSL Certificate</li>
      <li>24/7 Managed Support</li>
    </ul>
  </div>

  {/* Cloud Hosting Plan */}
  <div className="hosting-plan">
    <h3>Cloud Hosting</h3>
    <hr className="plan-divider" />
    <ul className="plan-features">
      <li>Scalable Cloud Infrastructure</li>
      <li>High Availability & Redundancy</li>
      <li>Pay-as-you-go Pricing</li>
      <li>SSD Storage with Fast I/O</li>
      <li>Auto Scaling Resources</li>
      <li>Global Data Centers</li>
      <li>Fully Managed Services</li>
      <li>Free Cloud Backup</li>
      <li>Instant Resource Upgrades</li>
      <li>24/7 Support & Monitoring</li>
    </ul>
  </div>

  {/* WordPress Hosting Plan */}
  <div className="hosting-plan">
    <h3>WordPress Hosting</h3>
    <hr className="plan-divider" />
    <ul className="plan-features">
      <li>Optimized for WordPress</li>
      <li>One-click WordPress Installation</li>
      <li>Free WP Themes & Plugins</li>
      <li>Managed Security & Updates</li>
      <li>Fast SSD Storage</li>
      <li>Free SSL Certificate</li>
      <li>Automatic Backups</li>
      <li>Expert WordPress Support</li>
      <li>Scalable Performance</li>
      <li>Unlimited Bandwidth</li>
    </ul>
  </div>
</div>

        </section>
<section className="hosting-solutions" id="cloud">
  <h2>Cloud & Infrastructure Hosting</h2>

  <div className="hosting-plans">
    {/* Cloud VPS Hosting Plan */}
    <div className="hosting-plan">
      <h3>Cloud VPS Hosting</h3>
      <hr className="plan-divider" />
      <ul className="plan-features">
        <li>Virtual Private Server in the Cloud</li>
        <li>Customizable Cloud Resources</li>
        <li>SSD Cloud Storage</li>
        <li>Full Root Access</li>
        <li>High Performance Cloud CPUs</li>
        <li>Elastic IP Address</li>
        <li>Auto Scaling Resources</li>
        <li>Cloud Security & DDoS Protection</li>
        <li>Automated Backups</li>
        <li>Pay-as-you-go Pricing</li>
        <li>24/7 Support & Monitoring</li>
      </ul>
    </div>

    {/* Cloud Dedicated Hosting Plan */}
    <div className="hosting-plan">
      <h3>Cloud Dedicated Hosting</h3>
      <hr className="plan-divider" />
      <ul className="plan-features">
        <li>Dedicated Cloud Servers</li>
        <li>Enterprise-grade Cloud Hardware</li>
        <li>Custom Cloud Configurations</li>
        <li>High Availability & Fault Tolerance</li>
        <li>Fully Managed Services</li>
        <li>Root Access & Flexibility</li>
        <li>Advanced Cloud Security & DDoS Protection</li>
        <li>Unlimited Scalable Traffic</li>
        <li>Free SSL Certificates</li>
        <li>24/7 Expert Cloud Support</li>
      </ul>
    </div>

    {/* Cloud Hosting Plan */}
    <div className="hosting-plan">
      <h3>Cloud Hosting</h3>
      <hr className="plan-divider" />
      <ul className="plan-features">
        <li>Scalable Cloud Infrastructure</li>
        <li>High Availability & Redundancy</li>
        <li>Pay-as-you-go Pricing</li>
        <li>SSD Storage with Fast I/O</li>
        <li>Auto Scaling Resources</li>
        <li>Global Data Centers</li>
        <li>Fully Managed Services</li>
        <li>Free Cloud Backup</li>
        <li>Instant Resource Upgrades</li>
        <li>24/7 Support & Monitoring</li>
      </ul>
    </div>

    {/* Cloud Infrastructure Hosting */}
    <div className="hosting-plan">
      <h3>Cloud Infrastructure Hosting</h3>
      <hr className="plan-divider" />
      <ul className="plan-features">
        <li>Elastic Cloud Infrastructure</li>
        <li>Global Cloud Availability</li>
        <li>Instant Scalability</li>
        <li>Pay-as-you-go Pricing</li>
        <li>Enterprise-grade Cloud Storage</li>
        <li>Cloud Load Balancing</li>
        <li>Advanced Security (IAM, DDoS Protection)</li>
        <li>Automated Backup & Disaster Recovery</li>
        <li>Global Monitoring & 24/7 Support</li>
      </ul>
    </div>

    {/* Cloud WordPress Hosting Plan */}
    <div className="hosting-plan">
      <h3>Cloud WordPress Hosting</h3>
      <hr className="plan-divider" />
      <ul className="plan-features">
        <li>Optimized WordPress Cloud Hosting</li>
        <li>One-click WordPress Installation</li>
        <li>Free WP Themes & Plugins</li>
        <li>Managed Security & Automatic Updates</li>
        <li>Fast SSD Storage with Cloud Scaling</li>
        <li>Free SSL Certificate</li>
        <li>Daily Automated Backups</li>
        <li>Expert WordPress Cloud Support</li>
        <li>Scalable Cloud Resources</li>
        <li>Unlimited Bandwidth & Global Availability</li>
      </ul>
    </div>

    {/* Cloud Backup Services */}
    <div className="hosting-plan">
      <h3>Cloud Backup Services</h3>
      <hr className="plan-divider" />
      <ul className="plan-features">
        <li>Automated Data Backups</li>
        <li>Secure Cloud Storage</li>
        <li>Scalable Backup Solutions</li>
        <li>Backup Encryption</li>
        <li>Disaster Recovery Options</li>
        <li>Fast Data Restoration</li>
        <li>Pay-as-you-go Pricing</li>
        <li>Global Availability</li>
        <li>24/7 Support</li>
      </ul>
    </div>

    {/* Cloud Migration Services */}
    <div className="hosting-plan">
      <h3>Cloud Migration Services</h3>
      <hr className="plan-divider" />
      <ul className="plan-features">
        <li>Seamless Migration to the Cloud</li>
        <li>Lift-and-shift Migration</li>
        <li>Cloud Optimization Services</li>
        <li>Cost-effective Solutions</li>
        <li>Security & Compliance during Migration</li>
        <li>Data Integrity Checks</li>
        <li>24/7 Expert Assistance</li>
        <li>Automated Migration Tools</li>
      </ul>
    </div>

    {/* Cloud Load Balancing */}
    <div className="hosting-plan">
      <h3>Cloud Load Balancing</h3>
      <hr className="plan-divider" />
      <ul className="plan-features">
        <li>Distribute Traffic Across Multiple Servers</li>
        <li>Auto-Scaling & High Availability</li>
        <li>Health Checks for Back-end Services</li>
        <li>Global Traffic Distribution</li>
        <li>Load Balancing for Web & Application Traffic</li>
        <li>Advanced Security Features (DDoS Protection)</li>
        <li>Fast Traffic Management</li>
        <li>Seamless Integration with Cloud Infrastructure</li>
      </ul>
    </div>

    {/* Cloud DevOps & CI/CD Services */}
    <div className="hosting-plan">
      <h3>Cloud DevOps & CI/CD Services</h3>
      <hr className="plan-divider" />
      <ul className="plan-features">
        <li>Automated Build & Deployment Pipelines</li>
        <li>Integrated Source Control</li>
        <li>Continuous Integration & Continuous Delivery</li>
        <li>Automated Testing & Monitoring</li>
        <li>Cloud-based Collaboration</li>
        <li>Scalable Infrastructure for DevOps</li>
        <li>Integrated with Containerization & Kubernetes</li>
        <li>Cloud-native Application Development</li>
      </ul>
    </div>

    {/* Cloud Analytics & Big Data Services */}
    <div className="hosting-plan">
      <h3>Cloud Analytics & Big Data Services</h3>
      <hr className="plan-divider" />
      <ul className="plan-features">
        <li>Scalable Data Processing</li>
        <li>Advanced Analytics Tools</li>
        <li>Data Warehousing & Reporting</li>
        <li>Real-time Data Streams</li>
        <li>Big Data Integration</li>
        <li>Machine Learning Integration</li>
        <li>Secure Data Storage</li>
        <li>Automated Data Processing</li>
      </ul>
    </div>

  </div>
</section>
		
        
{/* Contact Us Section */}
<section className="contact-us" id="contact-us">
  <h2>Contact Us</h2>
  <p>
    We'd love to hear from you! Get in touch for any inquiries, support requests, or business opportunities.
  </p>

  {/* Enquiry Form */}
  <form className="enquiry-form" onSubmit={handleSubmit}>
    <div className="form-group">
      <label htmlFor="name">Full Name <span className="required">*</span></label>
      <input
        type="text"
        id="name"
        name="name"
        placeholder="Enter your full name"
        value={formData.name}
        onChange={handleChange}
        required
      />
    </div>
    <div className="form-group">
      <label htmlFor="email">Email Address <span className="required">*</span></label>
      <input
        type="email"
        id="email"
        name="email"
        placeholder="Enter your email"
        value={formData.email}
        onChange={handleChange}
        required
      />
    </div>
    <div className="form-group">
      <label htmlFor="phone">Phone Number <span className="required">*</span></label>
      <input
        type="tel"
        id="phone"
        name="phone"
        placeholder="Enter your phone number"
        value={formData.phone}
        onChange={handleChange}
        required
      />
    </div>
    <div className="form-group">
      <label htmlFor="subject">Subject <span className="required">*</span></label>
      <input
        type="text"
        id="subject"
        name="subject"
        placeholder="Subject of your message"
        value={formData.subject}
        onChange={handleChange}
        required
      />
    </div>
    <div className="form-group">
      <label htmlFor="message">Message <span className="required">*</span></label>
      <textarea
        id="message"
        name="message"
        placeholder="Your message"
        rows="6"
        value={formData.message}
        onChange={handleChange}
        required
      ></textarea>
    </div>
    <div className="form-group">
      <button type="submit" className="submit-button">
        Submit
      </button>
    </div>
  </form>

  <div className="contact-info">
    <p>
      <FaEnvelope size={20} /> Email:{' '}
      <a href="mailto:sales@kloudsol.in">sales@kloudsol.in</a>
    </p>
  </div>
</section>



      </main>

      <footer className="App-footer">
        <p>&copy; 2025 Kloud Solutions. All rights reserved.</p>
      </footer>
    </div>
  );
}

export default App;
